/**
 * Customer Alias entity contract
 * Sourced from Dataverse entity cr001_customer_aliases
 */

/** Dataverse choice values for cr001_alias_type */
export enum AliasType {
  VendorMatching = 468190000,
  GlobalMatching = 468190001,
  ReferenceOnly = 468190002,
}

export const ALIAS_TYPE_LABELS: Record<AliasType, string> = {
  [AliasType.VendorMatching]: 'Vendor Matching',
  [AliasType.GlobalMatching]: 'Global Matching',
  [AliasType.ReferenceOnly]: 'Reference Only',
};

export interface CustomerAlias {
  aliasId: string;
  customerId: string;
  vendorId: string | null;
  vendorName: string | null;
  aliasType: AliasType;
  aliasTypeLabel: string;
  alias: string;
  aliasNormalized: string;
  isActive: boolean;
}

export interface CreateCustomerAliasRequest {
  alias: string;
  aliasType: AliasType;
  vendorId?: string | null;
  isActive?: boolean;
}

export interface UpdateCustomerAliasRequest {
  alias?: string;
  aliasType?: AliasType;
  vendorId?: string | null;
  isActive?: boolean;
}

export interface CustomerAliasListResponse {
  items: CustomerAlias[];
}
